"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * リソースHTML表示部品.
 * リソースに定義されている文字列をHTMLとして表示する。
 * @props {string} id - リソースID
 */
const ResourceHtml = function (props) {
  const {
    id,
    intl,
    className
  } = props;
  const contents = intl.formatMessage({
    id: id
  });
  return /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    className: className,
    dangerouslySetInnerHTML: {
      __html: contents
    }
  });
};
ResourceHtml.propTypes = {
  id: _propTypes.default.string
};
var _default = exports.default = (0, _reactIntl.injectIntl)(ResourceHtml);